import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import SectionHeading from "@/components/feature/SectionHeading";

const latestNews = [...newsList].sort((a, b) => b.date.localeCompare(a.date)).slice(0, 5);

export default function LatestNews() {
  return (
    <section>
      <SectionHeading
        eyebrow="LATEST"
        title="最新影视资讯"
        description="定档、开机、奖项与幕后动态，第一时间了解叶山小百合的影视近况。"
        actionLabel="查看全部资讯"
        actionTo="/news"
      />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        <Link
          to={`/news/detail/${latestNews[0].id}`}
          className="group relative lg:col-span-2 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-colors cursor-pointer min-h-[280px] md:min-h-[340px]"
        >
          <img
            src={latestNews[0].cover}
            alt={latestNews[0].title}
            title={`${latestNews[0].title} - 叶山小百合资讯`}
            className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/40 to-transparent"></div>
          <div className="relative h-full flex flex-col justify-end p-6 md:p-8">
            <span className="inline-flex w-fit px-2.5 py-1 rounded-md bg-accent-500 text-accent-950 text-xs font-medium mb-3">
              {latestNews[0].category} · 头条
            </span>
            <h3 className="font-heading text-lg md:text-2xl font-semibold text-background-50 leading-snug line-clamp-2">
              {latestNews[0].title}
            </h3>
            <p className="mt-3 text-sm text-background-50/75 leading-relaxed line-clamp-2 max-w-2xl">
              {latestNews[0].summary}
            </p>
            <span className="mt-4 text-xs text-background-50/60 flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-calendar-line text-xs"></i>
              </span>
              {latestNews[0].date}
            </span>
          </div>
        </Link>

        <div className="rounded-lg border border-background-200 bg-background-100 p-2">
          <ul>
            {latestNews.slice(1).map((item) => (
              <li key={item.id} className="border-b border-background-200 last:border-b-0">
                <Link
                  to={`/news/detail/${item.id}`}
                  className="group flex items-start gap-3 px-3 py-4 hover:bg-background-50 transition-colors cursor-pointer rounded-md"
                >
                  <span className="w-4 h-4 mt-1 flex items-center justify-center text-accent-600 shrink-0">
                    <i className="ri-article-line text-sm"></i>
                  </span>
                  <span className="min-w-0">
                    <span className="block text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </span>
                    <span className="block mt-1 text-xs text-foreground-500">{item.date}</span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}